import React, { useCallback, useContext, useEffect, useRef, useState, } from "react";
import { NavLink } from "react-router-dom";
import { LuUpload } from "react-icons/lu";
import CommonContext from "../../hooks/CommonContext";
import axios from "axios";
import toast from "react-hot-toast";
import { BsFiletypePdf } from "react-icons/bs";
import JobWorkSpaceRightContent from "./JobWorkSpaceRightContent";
import { useDropzone } from "react-dropzone";
import { IoIosInformationCircleOutline } from "react-icons/io";
import axiosInstance from "../../services/api/axiosInstance";
import { MdInfoOutline } from "react-icons/md";
import HomeAll from "../../views/professional/HomeOptionsLayout/HomeAll";
import HomeRecommended from "../../views/professional/HomeOptionsLayout/HomeRecommended";
import HomeSaved from "../../views/professional/HomeOptionsLayout/HomeSaved";
import HomeApplied from "../../views/professional/HomeOptionsLayout/HomeApplied";
import { SiGooglegemini } from "react-icons/si";
import ReactQuill, { Quill } from "react-quill";
import html2pdf from 'html2pdf.js';
import Cookie from "js-cookie";
import { decryptData } from "Security/Crypto/Crypto";

const JobWorkSpace = () => {
  const {
    setRecall, setRecallID, getRecommendedData, selectedCardPath,
    getHomeAll, isSmallDevice, setRefreshId, setRefreshAction,
    selectedCardData, answers, setAnswer, selectedCarrdLink,
    getSavedDatas, applyFilterCount, filteringObject, professionalMellieSearch,
    handleSelectedCardData, setSaveJobLoading, applyJobLoading, setApplyJobLoading,
    resumeDataFromResponse, setResumeDataFromResponse, handleCoverLetter, enhancedCoverLetterData,
    setEnhancedCoverLetterData, coverLetterLoading, setCoverLetterLoading, enhancedCoverLetter,
    setEnhancedCoverLetter, enhancedCoverLetterDataForPDF, cardArrayDuplicateSearch, currentPage,
    setCurrentPage, sortByForPagination, searchInput, setSearchInput,
    setapplyFilterResponse, sendingDataForProfessionalSearch,
    isSharedJob, isSelectedJob, setIsSharedJob, setSelectedCardPath
  } = useContext(CommonContext);

  const [resumeData, setResumeData] = useState([]);
  const [questionModal, setQuestionModal] = useState(false);
  const [modalBoxErr, setModalBoxErr] = useState(false);
  const [resumeSelected, setResumeSelected] = useState(false);
  const [coverLetterData, setCoverLetterData] = useState([]);
  const inputFile = useRef(null);
  const [modalApplyBtn, setmodalApplyBtn] = useState(false);
  const [isUploadedResume, setIsUploadedResume] = useState("NO")

  useEffect(() => {
    if (window.innerWidth <= 992 && Cookie.get("job_id")) {
      var getLocalStorageId = Cookie.get("job_id") ? decryptData(Cookie.get("job_id")) : '';
      handleSelectedCardData(getLocalStorageId);
      setIsSharedJob(true)
      setSelectedCardPath("/professional/all_jobs");
    }

    if (window.innerWidth <= 992 && Cookie.get("recommended_job_id")) {
      var getLocalStorageId = Cookie.get("recommended_job_id") ? decryptData(Cookie.get("recommended_job_id")) : '';
      handleSelectedCardData(getLocalStorageId);
      setSelectedCardPath(window.location.pathname);
      setIsSharedJob(true)
    }
  }, [])

  const handleReset = (getJobData) => {
    if (getJobData[0].user_resume) {
      setResumeDataFromResponse(`${process.env.REACT_APP_SECOND_CAREERS_CDN}professional/resume/${getJobData[0].user_resume}`)
    } else {
      setResumeDataFromResponse('')
    }

    setResumeData([]);
    setCoverLetterData([]);
    setModalBoxErr(false);
    setmodalApplyBtn(false);
    setApplyJobLoading(false);
    setEnhancedCoverLetterData('')
    setCoverLetterLoading(false)
    setEnhancedCoverLetter(false)

    const resetAnswer = answers.map((v) => {
      return { ...v, answer: '' }
    });
    setAnswer(resetAnswer);
  };

  const handleCopytext = () => {
    navigator.clipboard.writeText(selectedCarrdLink);
    toast.success("Link copied");
  };

  const handleSaveJob = async (value) => {
    setSaveJobLoading(true)
    let jobSaveParams = { job_id: value };
    try {
      const response = await axiosInstance.post("/professional_job_save", jobSaveParams)
      if (response.data.error_code === 0) {
        setAnswer([])
        handleSelectedCardData(value, "job-Saving");

      }
      if (response.data.error_code === 403) {
        toast.error(response.data.message);
      }
    } catch (err) {
      console.log(err)
    }
  };

  const handleAnswer = (event, questionId) => {
    const editAnswer = answers.map((v) => {
      return v.question_id === questionId
        ? { ...v, answer: event.target.value }
        : v;
    });

    setAnswer(editAnswer);
  };

  const recallGetAllJobs = () => {
    setAnswer([]);
    //apply filter
    if (applyFilterCount > 0) {
      setapplyFilterResponse(true);
      setSearchInput("");
      if (cardArrayDuplicateSearch?.length > 1) {
        professionalMellieSearch(filteringObject, currentPage + 1);
      } else {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1)
          professionalMellieSearch(filteringObject, currentPage);
        } else {
          professionalMellieSearch(filteringObject, 1);
          setCurrentPage(1)
        }
      }
    } else {
      //search 
      if (searchInput) {
        setapplyFilterResponse(true);
        if (cardArrayDuplicateSearch?.length > 1) {
          const obj = {
            search_text: searchInput.trim(),
            page_number: currentPage + 1
          }
          sendingDataForProfessionalSearch("/search_result", obj);
        } else {
          if (currentPage > 1) {
            const obj = {
              search_text: searchInput.trim(),
              page_number: currentPage
            }
            setCurrentPage(currentPage - 1)
            sendingDataForProfessionalSearch("/search_result", obj);
          } else {
            const obj = {
              search_text: searchInput.trim(),
              page_number: 1
            }
            sendingDataForProfessionalSearch("/search_result", obj);
            setCurrentPage(1)
          }
        }
      }

      //default
      else {
        setSearchInput("");
        if (cardArrayDuplicateSearch?.length > 1) {
          getHomeAll("pagination", currentPage + 1, sortByForPagination);
        } else {
          if (currentPage > 1) {
            setCurrentPage(currentPage - 1)
            getHomeAll("pagination", currentPage, sortByForPagination);
          } else {
            getHomeAll("pagination", 1, sortByForPagination)
            setCurrentPage(1)
          }
        }
      }
    }
  }

  const handleFormDataApplyJob = async (e) => {
    e.preventDefault();
    var l = []
    const date = new Date();
    l.push(date.getDate());
    l.push(date.getMonth());
    l.push(date.getUTCFullYear());
    l.push(date.getUTCMilliseconds());

    const dateForBlobName = l.join("")

    const options = {
      margin: [10, 20, 10, 20],
      filename: 'html_content.pdf',
      image: { type: 'jpeg', quality: 100 },
      html2canvas: { scale: 1.5 }, // Optional: improves rendering quality
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

    const htmlContent = `<div style={{fontSize: '16px', width: '100%', padding: '40px'}}>
      ${enhancedCoverLetterData}
    </div>`

    const pdfBlob = await html2pdf().from(htmlContent).set(options).outputPdf('blob');

    setApplyJobLoading(true)
    setmodalApplyBtn(true);
    const checkAnswers = answers.filter((v) => {
      return v.answer.length === 0;
    });

    if (
      checkAnswers.length === 0 && ((resumeData.length > 0 || resumeDataFromResponse !== '' && selectedCardData[0].required_resume === "Y") || selectedCardData[0].required_resume === "N") &&
      (((enhancedCoverLetter && pdfBlob) || coverLetterData.length > 0 &&
        selectedCardData[0].required_cover_letter === "Y") ||
        selectedCardData[0].required_cover_letter === "N")
    ) {
      setModalBoxErr(false);
      const fd = new FormData();

      if (isUploadedResume === "YES") {
        fd.append("resume", selectedCardData[0].required_resume === "Y" ? resumeData[0] : null);
        fd.append("resume_name", selectedCardData[0].required_resume === "Y" ? "" : null);
      } else {
        fd.append("resume", selectedCardData[0].required_resume === "Y" ? null : null);
        fd.append("resume_name", selectedCardData[0].required_resume === "Y" ? selectedCardData[0].user_resume : null);
      }

      if (enhancedCoverLetter) {
        fd.append("cover_letter", selectedCardData[0].required_cover_letter === "Y" ?
          pdfBlob
          :
          null
          , `cover_letter${dateForBlobName}.pdf`);
      } else {
        fd.append("cover_letter", selectedCardData[0].required_cover_letter === "Y" ?
          coverLetterData[0]
          :
          null
        );
      }

      fd.append("job_id", selectedCardData[0].id);

      if (answers.length > 0) {
        fd.append("status_questions_list", 1);
        answers.forEach((obj, index) => {
          Object.entries(obj).forEach(([key, value]) => {
            fd.append(`questions_list[${index}][${key}]`, value);
          });
        });
      } else {
        fd.append("status_questions_list", null);
      }

      try {
        const token = Cookie.get("pToken");;
        await axios
          .post(`${process.env.REACT_APP_API_URL}/professional_job_apply`, fd, {
            headers: {
              "content-type": "multipart/form-data",
              authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setAnswer([]);
            document.getElementById("closeApplyModal").click();
            if (res.data.error_code === 0) {
              toast.success(res.data.message);

              if (isSmallDevice) {
                setRefreshId(selectedCardData[0].id + 100);
                setRefreshAction(true);
                setQuestionModal(false);
                setmodalApplyBtn(false);
                setRecall(true);
                setRecallID(selectedCardData[0].id);
                if (selectedCardPath === "/professional/all_jobs") {
                  getHomeAll();
                }
                if (
                  selectedCardPath === "/professional/recommended_jobs"
                ) {
                  getRecommendedData();
                }
                if (selectedCardPath === "/professional/saved_jobs") {
                  getSavedDatas();
                }
              } else {
                if (selectedCardPath === "/professional/all_jobs") {
                  setQuestionModal(false);
                  setmodalApplyBtn(false);
                  setRecall(true);
                  setRecallID(selectedCardData[0].id);
                  recallGetAllJobs()
                } else {
                  setRefreshId(selectedCardData[0].id + 100);
                  setRefreshAction(true);
                  setQuestionModal(false);
                  setmodalApplyBtn(false);
                  setRecall(true);
                  setRecallID(selectedCardData[0].id);
                }
              }
            } else {
              toast.error(res.data.message);
            }
            setApplyJobLoading(false)
          })
          .catch((err) => console.log(err));
      } catch (err) {
        console.log(err);
      }
    } else {
      setModalBoxErr(true);
      setApplyJobLoading(false);
      toast("Some fields are empty", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    }
    setmodalApplyBtn(false);
  };

  const handleNoRequirementsApplyJob = async () => {
    setApplyJobLoading(true)
    const fd = new FormData();
    fd.append("resume", null);
    fd.append("resume_name", "");
    fd.append("cover_letter", null);
    fd.append("job_id", selectedCardData[0].id);
    fd.append("status_questions_list", null);
    answers.forEach((obj, index) => {
      Object.entries(obj).forEach(([key, value]) => {
        fd.append(`questions_list[${index}][${key}]`, value);
      });
    });

    try {
      const token = Cookie.get("pToken");;
      await axios
        .post(`${process.env.REACT_APP_API_URL}/professional_job_apply`, fd, {
          headers: {
            "content-type": "multipart/form-data",
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setAnswer([]);
          if (res.data.error_code === 0) {
            toast.success(res.data.message);

            if (isSmallDevice) {
              setRefreshId(selectedCardData[0].id + 1000);
              setRefreshAction(true);
              setQuestionModal(false);
              setRecallID(selectedCardData[0].id);
              setRecall(true);
              if (selectedCardPath === "/professional/all_jobs") {
                getHomeAll();
              }
              if (selectedCardPath === "/professional/recommended_jobs") {
                getRecommendedData();
              }
              if (selectedCardPath === "/professional/saved_jobs") {
                getSavedDatas();
              }
            } else {
              setQuestionModal(false);
              setRecallID(selectedCardData[0].id);
              setRecall(true);
              if (selectedCardPath === "/professional/all_jobs") {
                recallGetAllJobs()
              } else {
                setRefreshId(selectedCardData[0].id + 1000);
                setRefreshAction(true);
                setQuestionModal(false);
                setmodalApplyBtn(false);
                setRecall(true);
                setRecallID(selectedCardData[0].id);
              }
            }
          } else if (res.data.error_code === 201) {
            toast.error(res.data.message);
          } else {
            toast.error(res.data.message);
          }
          setApplyJobLoading(false);
        })
        .catch((err) => console.log(err));
    } catch (err) {
      console.log(err);
    }
  };

  const onDropResume = useCallback((acceptedFiles) => {
    var fileSize = acceptedFiles[0].size
    if (fileSize <= 5242880) {
      setResumeData(acceptedFiles);
      setIsUploadedResume("YES")
    } else {
      toast.error("Please ensure that the file size remains below 5MB")
    }
  }, []);

  const {
    getRootProps: getRootPropsResume,
    getInputProps: getInputPropsResume,
    isDragActive: isDragActiveResume,
  } = useDropzone({
    onDrop: onDropResume,
    maxFiles: 1,
    accept: {
      "application/pdf": [],
    },
  });

  const onDropCoverLetter = useCallback((acceptedFiles) => {
    var fileSize = acceptedFiles[0].size
    if (fileSize <= 5242880) {
      setCoverLetterData(acceptedFiles);
    } else {
      toast.error("Please ensure that the file size remains below 5MB")
    }
  }, []);

  const {
    getRootProps: getRootPropsCoverLetter,
    getInputProps: getInputPropsCoverLetter,
    isDragActive: isDragActiveCoverLetter,
  } = useDropzone({
    onDrop: onDropCoverLetter,
    maxFiles: 1,
    accept: {
      "application/pdf": [],
    },
  });

  const getresumeName = (resume) => {
    const splitResume = resume.split('/')

    return splitResume[splitResume.length - 1]
  }

  const handleDynamicPage = () => {
    switch (window.location.pathname) {
      case "/professional/all_jobs":
        return <HomeAll />

      case "/professional/recommended_jobs":
        return <HomeRecommended />

      case "/professional/applied_jobs":
        return <HomeApplied />

      case "/professional/saved_jobs":
        return <HomeSaved />

      default:
        break;
    }
  }

  // React Quill Editor
  const modules = {
    toolbar: [
      [{ 'size': ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' },
      { 'indent': '-1' }, { 'indent': '+1' }],

    ],
  };
  const Size = Quill.import('formats/size');
  Size.whitelist = ['small', false, 'large', 'huge'];
  Quill.register(Size, true);

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
  ];

  return (
    <>
      <div className="container-fluid">
        <div className={(isSelectedJob || isSharedJob) && isSmallDevice ?
          "setting-row-height-minimumDevice row mt-4"
          :
          "row mt-1 setting-row-height p-3 pt-0"
        }
        >
          {(isSelectedJob || isSharedJob) && isSmallDevice ?
            null
            :
            <div className="h-100 col-12 col-lg-6 d-flex p-0">
              {handleDynamicPage()}
            </div>
          }

          <JobWorkSpaceRightContent
            handleNoRequirementsApplyJob={handleNoRequirementsApplyJob}
            handleFormDataApplyJob={handleFormDataApplyJob}
            handleAnswer={handleAnswer}
            handleSaveJob={handleSaveJob}
            handleCopytext={handleCopytext}
            handleReset={handleReset}
            questionModal={questionModal}
            setQuestionModal={setQuestionModal}
            modalBoxErr={modalBoxErr}
            setModalBoxErr={setModalBoxErr}
            resumeData={resumeData}
            setResumeData={setResumeData}
            resumeSelected={resumeSelected}
            setResumeSelected={setResumeSelected}
            coverLetterData={coverLetterData}
            setCoverLetterData={setCoverLetterData}
            inputFile={inputFile}
            deviceResolution={(isSelectedJob || isSharedJob) && isSmallDevice ? "smallDevice" : ""}
          />
        </div>

        {/* apply job modal box  */}
        {window.location.pathname !== "/professional/applied_jobs" ? (
          <div
            className="modal fade"
            id="ApplyJobModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg ">
              <div className="modal-content p-2">

                {/* enhancedCoverLetterData */}
                <div className="DummyCoverLetterText">
                  <div style={{ fontSize: '16px', width: '100%', padding: '10px' }}>
                    {enhancedCoverLetterDataForPDF}
                  </div>
                </div>

                <form ref={inputFile} onSubmit={handleFormDataApplyJob}>
                  <div className="modal-header border-0">
                    <h1 className="modal-title fs-5" id="staticBackdropLabel">
                      Apply for job
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="closeApplyModal"

                      onClick={() => handleReset(selectedCardData)}
                    ></button>
                  </div>
                  <div className="modal-body apply-job-modal-height overflow-scroll">
                    <div className="container">
                      {selectedCardData.length > 0 &&
                        selectedCardData[0] !== undefined ?
                        <>
                          {
                            selectedCardData[0].required_resume !== undefined ?
                              selectedCardData[0].required_resume === "Y" ?
                                <>
                                  <h5 className="my-3">Please upload a resume</h5>
                                  {
                                    resumeDataFromResponse !== "" ?
                                      <div className="card border-0">
                                        <div className="card-body">
                                          <div className="row align-items-center">
                                            {/* existing resume pdf  */}
                                            <div className="border rounded-3 uploaded-resume d-inline-flex flex-wrap align-items-center col-12 col-lg-5" onClick={() => setIsUploadedResume("NO")}>
                                              <div className="fs-2 col-2 col-md-3 text-center d-inline-flex align-items-center">
                                                <input className="form-check-input apply-radio" type="radio" name="flexRadioDefault" onChange={(e) => setIsUploadedResume(e.target.value)} value="NO" checked={isUploadedResume === "NO"} />
                                                <BsFiletypePdf className="apply-job-brand-color ms-2" />
                                              </div>
                                              <div className="col-10 col-md-9">
                                                <p className="resume-name m-0">
                                                  {getresumeName(resumeDataFromResponse)}
                                                </p>
                                              </div>
                                            </div>

                                            {/* or */}
                                            <div className="col-12 col-lg-1 text-center">
                                              <p className="mb-0">Or</p>
                                            </div>

                                            {/* upload new resume */}
                                            <div className="col-12 col-lg-6 border rounded-3">
                                              {
                                                resumeData.length > 0 ?
                                                  <div className="row align-items-center">
                                                    <div className="uploaded-resume d-inline-flex flex-wrap align-items-center col-12" onClick={() => setIsUploadedResume("YES")}>
                                                      <div className="fs-2 col-2 col-md-3 text-center d-inline-flex align-items-center">
                                                        <input className="form-check-input apply-radio" type="radio" name="flexRadioDefault" onChange={(e) => setIsUploadedResume(e.target.value)} value="YES" checked={isUploadedResume === "YES"} />
                                                        <BsFiletypePdf className="apply-job-brand-color ms-2" />
                                                      </div>

                                                      <div className="col-10 col-md-7">
                                                        <p className="resume-name m-0">
                                                          {resumeData[0].name !==
                                                            undefined
                                                            ? resumeData[0].name
                                                            : null}
                                                        </p>
                                                      </div>

                                                      <div className="col-2 px-3 gap-3 mt-2 text-end">
                                                        <LuUpload
                                                          className="upload-icon fs-4 brand-color"
                                                          title="Upload New Resume"
                                                          onClick={() => {
                                                            setResumeData([])
                                                          }}
                                                          {...getRootPropsResume()}
                                                        />
                                                      </div>
                                                    </div>


                                                  </div>
                                                  :
                                                  <div
                                                    {...getRootPropsResume()}
                                                    className="cursorPointer"
                                                  >
                                                    <input {...getInputPropsResume()} />
                                                    {isDragActiveResume ? (
                                                      <div className="card-body d-flex flex-wrap align-items-center justify-content-center p-0">
                                                        <div className="w-100 py-4 row align-items-center">
                                                          <div className="fs-2 col-2 col-md-1 text-center">
                                                            <LuUpload className="apply-job-brand-color" />
                                                          </div>
                                                          <div className="col-10 col-md-11">
                                                            <p className="mb-0 apply-job-brand-color">Drop the files here ...</p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      <div className="card-body p-0">
                                                        <div className="w-100 py-4 pb-2 d-flex flex-wrap">
                                                          <div className="fs-2 col-2 col-md-3 d-inline-flex mt-2">
                                                            <input className="form-check-input apply-radio" type="radio" name="flexRadioDefault" value="YES" checked={isUploadedResume === "YES"} />
                                                            <LuUpload className="apply-job-brand-color ms-2" />
                                                          </div>
                                                          <div className="col-10 col-md-9">
                                                            <p className="mb-0 ">Upload your resume</p>
                                                            <p className="text-secondary"> (Only PDF format is supported)</p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      :
                                      <div className="col-12 rounded-3">
                                        {
                                          resumeData.length > 0 ?
                                            <div className="card border-0 h-100 rounded-2 ">
                                              <div className="card-body border rounded-3">
                                                <div className="row align-items-center px-1">
                                                  <div className="p-1 uploaded-resume-container d-flex flex-wrap align-items-center col-10">
                                                    <div className="fs-2 col-2 col-md-1 text-center">
                                                      <BsFiletypePdf className="pdf-icon me-3 fs-2 apply-job-brand-color" />
                                                    </div>
                                                    <div className="col-10 col-md-11">
                                                      <p className="resume-name m-0">
                                                        {resumeData[0].name !==
                                                          undefined
                                                          ? resumeData[0].name
                                                          : null}
                                                      </p>
                                                    </div>
                                                  </div>
                                                  <div className="col-2 px-3 gap-3 mt-2 text-end">
                                                    <LuUpload
                                                      className="upload-icon fs-4 brand-color"
                                                      title="Upload New Resume"
                                                      onClick={() => {
                                                        setResumeData([])
                                                      }}
                                                      {...getRootPropsResume()}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            :
                                            <div
                                              {...getRootPropsResume()}
                                              className="cursorPointer"
                                            >
                                              <input {...getInputPropsResume()} />
                                              {isDragActiveResume ? (
                                                <div className="card-body d-flex flex-wrap align-items-center justify-content-center p-0">
                                                  <div className="uploadFile-dotted-border w-100 py-4 row align-items-center">
                                                    <div className="fs-2 col-2 col-md-1 text-center">
                                                      <LuUpload className="apply-job-brand-color" />
                                                    </div>
                                                    <div className="col-10 col-md-11">
                                                      <p className="mb-0 apply-job-brand-color">Drop the files here ...</p>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div className="card-body p-0 mb-3">
                                                  <div className="uploadFile-dotted-border rounded-3 w-100 py-3 pb-2 d-flex flex-wrap">
                                                    <div className="fs-2 col-2 col-md-1 text-center">
                                                      <LuUpload className="apply-job-brand-color" />
                                                    </div>
                                                    <div className="col-10 col-md-11">
                                                      <p className="mb-0 ">Upload your resume</p>
                                                      <p className="text-secondary"> (Only PDF format is supported)</p>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                        }
                                      </div>
                                  }
                                </>
                                :
                                null
                              :
                              null
                          }

                          {
                            selectedCardData[0].required_cover_letter !== undefined ?
                              selectedCardData[0].required_cover_letter === "Y" ?
                                <div className="mt-3">
                                  <div className="col-12 d-flex flex-wrap align-items-center">
                                    <div className="col-6">
                                      <h5 className="my-3">Please upload cover letter</h5>
                                    </div>
                                    <div className="col-6 text-end pe-0">
                                      <button type="button" className="btn btn-brand-color" onClick={handleCoverLetter} disabled={enhancedCoverLetter}>
                                        Draft with AI
                                        <SiGooglegemini className="ms-1 fs-5" />
                                      </button>
                                    </div>
                                  </div>
                                  <div className="col-12 my-3 mt-1">
                                    <div className="card border-0 h-100">
                                      {
                                        enhancedCoverLetter ?
                                          coverLetterLoading ?
                                            <div className="col-12 loading-height row align-items-center justify-content-center">
                                              <div className="spinner-border text-warning" role="status"></div>
                                            </div>
                                            :
                                            <ReactQuill
                                              id='quillEditor'
                                              style={{ height: '200px', marginBottom: '3rem', height: '20rem', borderRadius: '2rem' }}
                                              theme="snow"
                                              modules={modules}
                                              formats={formats}
                                              value={enhancedCoverLetterData}
                                              onChange={(e) => {
                                                setEnhancedCoverLetterData(e)
                                              }}
                                            />
                                          :
                                          coverLetterData.length > 0 ?
                                            <div className="card border-0 h-100 rounded-2 ">
                                              <div className="card-body border rounded-3">
                                                <div className="row align-items-center px-1">
                                                  <div className="p-1 uploaded-resume-container d-flex flex-wrap align-items-center col-10">
                                                    <div className="fs-2 col-2 col-md-1 text-center">
                                                      <BsFiletypePdf className="pdf-icon me-3 fs-2 apply-job-brand-color" />
                                                    </div>
                                                    <div className="col-10 col-md-11">
                                                      <p className="resume-name mb-0">
                                                        {coverLetterData[0].name !==
                                                          undefined
                                                          ? coverLetterData[0].name
                                                          : null}
                                                      </p>
                                                    </div>
                                                  </div>
                                                  <div className="col-2 px-3 gap-3 mt-2 text-end">
                                                    <LuUpload
                                                      className="upload-icon fs-4 brand-color"
                                                      title="Upload New Resume"
                                                      onClick={() =>
                                                        setCoverLetterData([])
                                                      }
                                                      {...getRootPropsCoverLetter()}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            :
                                            <div
                                              {...getRootPropsCoverLetter()}
                                              className="cursorPointer"
                                            >
                                              <input {...getInputPropsCoverLetter()} />
                                              {isDragActiveCoverLetter ? (
                                                <div className="card-body d-flex flex-wrap align-items-center justify-content-center p-0">
                                                  <div className="uploadFile-dotted-border rounded-3 w-100 py-3 row align-items-center">
                                                    <div className="fs-2 col-2 col-md-1 text-center">
                                                      <LuUpload className="apply-job-brand-color" />
                                                    </div>
                                                    <div className="col-10 col-md-11">
                                                      <p className="mb-0 apply-job-brand-color">Drop the files here ...</p>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div className="card-body p-0 mb-3">
                                                  <div className="uploadFile-dotted-border rounded-3 w-100 py-4 d-flex flex-wrap">
                                                    <div className="fs-2 col-2 col-md-1 text-center">
                                                      <LuUpload className="apply-job-brand-color" />
                                                    </div>
                                                    <div className="col-10 col-md-11">
                                                      <p className="mb-0">Upload your cover letter</p>
                                                      <p className="text-secondary mb-0"> (Only PDF format is supported)</p>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                      }
                                    </div>

                                    {coverLetterData.length === 0 && modalBoxErr ? (
                                      <div className="col-12">
                                        <p className="text-danger mt-2">
                                          Cover Letter Required
                                        </p>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                :
                                null
                              :
                              null
                          }

                          {
                            answers.length > 0
                              ? selectedCardData[0].questions.map((v, i) => {
                                return (
                                  <div key={i}>
                                    <div className="row mb-2 ">
                                      <div className="col-lg-12 d-flex justify-content-between">
                                        <h6 className="text-break">{v.custom_pre_screen_ques}</h6>
                                      </div>
                                    </div>
                                    <div className="container">
                                      <div className="row">
                                        <textarea
                                          className="p-3 rounded-3 mb-3 border "
                                          value={answers[i].answer}
                                          onChange={(e) =>
                                            handleAnswer(e, v.id)
                                          }
                                          required
                                          maxLength={10000}
                                          rows={4}
                                          placeholder="Enter your text here.."
                                        />

                                        {answers[i].answer === "" &&
                                          modalBoxErr ? (
                                          <div className="col-12">
                                            <p className="text-danger">
                                              fields are empty
                                            </p>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                              :
                              null
                          }
                        </>
                        :
                        null
                      }
                    </div>
                  </div>
                  <div className="modal-footer border-0">
                    <div className="container m-0">
                      <div className="row float-end">
                        <div className="col-lg-12 ">
                          {
                            applyJobLoading ?
                              <button className="btn btn-brand-color pe-none" type="button">
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span className="ps-2 d-none d-lg-inline">Applying...</span>
                              </button>
                              :
                              <button
                                type="submit"
                                className="btn btn-brand-color my-2 px-5"
                                id="applyNowBtn"
                                disabled={modalApplyBtn || coverLetterLoading}
                              >
                                Apply
                              </button>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : null}

        {/* ApplyJobModalErrorBox */}
        <div
          className="modal fade"
          id="ApplyJobModalErrorBox"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-md vh-50">
            <div className="modal-content p-2">
              <div className="modal-header border-bottom-0">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="closeApplyModalError"
                ></button>
              </div>
              <div className="modal-body border-bottom-0 pb-5">
                <div className="row justify-content-center text-center">
                  <MdInfoOutline className="applyJobErrorModal" />
                  <p className="pt-3 ">Please take a few moments to complete your profile to apply for the job.Click here to go to <NavLink to="/professional/profile" onClick={() => document.getElementById('closeApplyModalError').click()}> My profile</NavLink>.</p>

                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Share Modal */}
        <div
          className="modal fade"
          id="shareModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Share
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body pt-0 ">
                <div className="mb-5 position-relative">
                  <label htmlFor="message-text" className="col-form-label mb-2">
                    Copy link
                  </label>
                  <input
                    className="form-control  mx-auto mt-0 linkFieldSize"
                    id="message-text"
                    value={selectedCarrdLink}
                    readOnly
                  />
                  <button
                    type="button"
                    className="btn btn-brand-color button-position"
                    onClick={handleCopytext}
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobWorkSpace;